<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loadingFromApi">
                    <form @submit.prevent="addOrUpdateComboDiscountGroup">
                        <div class="form-group">
                            <label for="nameInput">
                                Name
                            </label>
                            <div class="text-danger" v-if="comboDiscountGroupAddEditForm.comboDiscountGroup.name.hasError">
                                {{comboDiscountGroupAddEditForm.comboDiscountGroup.name.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="nameInput" v-model="comboDiscountGroupAddEditForm.comboDiscountGroup.name.value"/>
                        </div>
                        <div class="form-group">
                            <label for="discountAmountInput">
                                Discount Amount
                            </label>
                            <div class="text-danger" v-if="comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.hasError">
                                {{comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.errorMessage}}
                            </div>
                            <currency-input class="form-control" v-model="comboDiscountGroupAddEditForm.comboDiscountGroup.discountAmount.value"
                                            @change="onDiscountAmountChange"
                                            :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false }"></currency-input>
                        </div>
                        
                        <div class="products-section">
                            <h5>Products</h5>
                            <div class="text-danger" v-if="comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.hasError">
                                {{comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.errorMessage}}
                            </div>
                            <button class="btn btn-primary float-right" @click.prevent="onLinkProductsClick">
                                Link Products
                            </button>
                            <data-table
                                    :headings="productsToLinkHeadings"
                                    :data="comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value"
                                    :hasActions="true"
                                    :hasCustomActionComponent="true"
                                    :hasNoFilter="true"
                                    :hasNoPaging="true">
                                <template #actionComponent="{ productId }">
                                    <button class="btn btn-link" @click.prevent="onProductUnlink(productId)">
                                        Unlink
                                    </button>
                                </template>
                            </data-table>
                        </div>

                        <div class="form-group effective-date-section">
                            <label for="effectiveDateInput">
                                Effective Date
                            </label>
                            <div class="text-danger" v-if="comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.hasError">
                                {{comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.errorMessage}}
                            </div>
                            <input type="date" class="form-control" id="effectiveDateInput" v-model="comboDiscountGroupAddEditForm.comboDiscountGroup.effectiveDate.value"/>
                        </div>

                        <button class="btn btn-primary mr-2" :disabled="loading">Save</button>
                        <button class="btn btn-secondary" @click.prevent="onBackClick" :disabled="loading">Back</button>
                    </form>
                </div>
                <loading-spinner :showSpinner="loadingFromApi"></loading-spinner>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading"
                 :elementId="errorModal.elementId"
                 :modalMessage="errorModal.modalMessage"
                 :showModal="errorModal.showModal"
                 @okClicked="errorModelOkClicked"></error-modal>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModelOkClicked"></success-modal>

    <link-products-to-combo-discount-group-modal
            :heading="linkProductsToComboDiscountGroupModal.heading"
            :modalId="linkProductsToComboDiscountGroupModal.modalId"
            :showModal="linkProductsToComboDiscountGroupModal.showModal"
            :comboDiscountGroupId="linkProductsToComboDiscountGroupModal.comboDiscountGroupId"
            :currentLinkedProducts="comboDiscountGroupAddEditForm.comboDiscountGroup.linkedProducts.value"
            @closeClicked="onLinkProductsToComboDiscountGroupModalCloseClick"
            @saveButtonClicked="onLinkProductsToComboDiscountGroupSaveClick">
    </link-products-to-combo-discount-group-modal>
</div>